module.exports = __webpack_public_path__ + "img/dz.30c25de4.png";